import React, { useState, useEffect } from 'react';
import { Tabs, Tab, Paper, withStyles, IconButton, Tooltip, Box } from '@material-ui/core';

import Typography from '@material-ui/core/Typography';
import { connect } from 'react-redux';
import { Refresh } from '@material-ui/icons';

import { parseURL, BackButton, hasPermission, formatDate } from '../../sc-utilities';

import { snackActions } from '../../sc-utilities/SnackBar';
import * as pcProductActions from '../PCProduct/store/pcProductActions';
import * as mobileProductActions from './store/mobileProductActions';
import MobileProductMisc from './Details/MobileProductEditMisc';
import { downloadFile, updateURL } from '../../sc-utilities';
import { getMediaArrays } from '../../sc-media/utilities';
import config from '../../../config/config';
//import Presets from '../../sc-settings/Presets';

import * as baseboardActions from '../../sc-productComponents/Baseboard/store/baseboardActions';
import * as batteryActions from '../../sc-productComponents/Battery/store/batteryActions';
import * as cpuActions from '../../sc-productComponents/CPU/store/cpuActions';
import * as gpuActions from '../../sc-productComponents/GPU/store/gpuActions';
import * as memoryActions from '../../sc-productComponents/Memory/store/memoryActions';
import * as nicActions from '../../sc-productComponents/NIC/store/nicActions';
import * as storageActions from '../../sc-productComponents/Storage/store/storageActions';
import ProductDontLoading from '../ProductDontLoading';

import ProductDetails from './MobileProductEditDetails';
import MediaGallery from '../../sc-media/MediaGallery';
import StorageList from '../../sc-productComponents/Storage';
import BatteryList from '../../sc-productComponents/Battery';
import MemoryList from '../../sc-productComponents/Memory';
// import DiagnoseList from '../Diagnose/DiagnoseTab';
import Report from '../../sc-productComponents/Report';
import OEMPart from '../../sc-oemPart';
import {useChangeActiveCustomerModalHook} from "../hooks/useChangeActiveCustomerModalHook";
import StatisticModal from "../../sc-dashboard/Statistic/StatisticModal";
import {handleChangeCustomer} from "../../sc-dashboard/Statistic";
import * as action from "../../np-dashboard/CustomerBar/store/actions";
import MobileProductAuditRecord from "../../sc-productComponents/MobileProductAuditRecord";
import Diagnose from '../../sc-diagnose/Diagnose';

const styles = theme => ({
    root: {
        width: `98.9%`,
        height: 'auto',

        margin: theme.spacing(),

        [theme.breakpoints.down('md')]: {
            width: `97.8%`
        },
        [theme.breakpoints.down('sm')]: {
            width: `97.8%`
        }
    },
});

const TabContainer = props => {
    return (
        <Typography component="div" dir={props.dir} style={{ padding: 6, marginTop: '1%' }}>
            {props.children}
        </Typography>
    );
};
const getTabValue = () => {
    let urlArray = window.location.href.split('#');
    return urlArray.length > 1 ? Number(urlArray[1]) : 0;
};
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index || props.disabled}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {((value === index || value < 6)) && (
                <Box p={3} style={{ padding: '0px' }} disabled={true}>
                    {children}
                </Box>
            )}
        </div>
    );
}

const ProductComponents = props => {
    const { classes, theme, onFetchMobileProduct, activeCustomer, onGenerateReportMobile, productEditable, fetchMobileOrders, permissions, onCleanBaseboard, onCleanBattery, translations, onCleanCpu, onCleanGpu, onCleanMemory, onCleanNic, onCleanStorage, onCleanMobileState, mobileProducts, onChangeActiveCustomer } = props;
    let searchParams = parseURL(window.location.search);
    const [tabValue, setTabValue] = useState(getTabValue());
    const [editable, setEditable] = useState({ editable: false, loading: false });
    const [signatures, setSignatures] = useState([]);
    const [mediaArrays, setMediaArrays] = useState({ videoArray: [], audioArray: [], imageArray: [] });
    const [deletedMedia, setDeletedMedia] = useState(false);
    const [refresh, setRefresh] = useState(false);

    const [redirectOptions, setRedirectOptions] = useChangeActiveCustomerModalHook(searchParams, activeCustomer);

    useEffect(() => {
        const fetchData = async () => {
            let isEditable = await productEditable({ ProductID: searchParams.productID, ActiveCustomerID: activeCustomer });
            setEditable({ editable: isEditable.productEditable, loading: true });
        }
        fetchData();
        return () => { };
    }, [activeCustomer, productEditable, searchParams.productID]);

    useEffect(() => {
        return () => {
            onCleanMobileState();
            onCleanBaseboard();
            onCleanBattery();
            onCleanCpu();
            onCleanGpu();
            onCleanMemory();
            onCleanNic();
            onCleanStorage();
        };
    }, [onCleanMobileState, onCleanBaseboard, onCleanBattery, onCleanCpu, onCleanGpu, onCleanMemory, onCleanNic, onCleanStorage]);

    useEffect(() => {

        if (mobileProducts && mobileProducts.loaded && mobileProducts.loaded.Media && mobileProducts.loaded.Media.length > 0) {
            const media = getMediaArrays(mobileProducts.loaded.Media);
            setMediaArrays({ imageArray: media.tempImages, videoArray: media.tempVideos, audioArray: media.tempAudio });
        }

        if (mobileProducts && mobileProducts.loaded && mobileProducts.loaded.Signatures && mobileProducts.loaded.Signatures.length > 0) {
            let tempSignatures = [];
            const signaturePath = `${config.backend_domain}:${config.backend_port}/static-signature/`;

            mobileProducts.loaded.Signatures.forEach((signature) => {
                if (!signature.Deleted) {
                    tempSignatures.push({
                        id: signature.SignatureID,
                        path: signaturePath + signature.ImageLocation,
                        type: 'signature',
                        createdAt: signature.CreatedAt ? formatDate(signature.CreatedAt) : ''
                    });
                }
            });
            setSignatures(tempSignatures);
        }
    }, [mobileProducts]);

    const unlockEdit = () => {
        setEditable({ editable: true, loading: true });
        snackActions.snackBarComponent(`${translations['cant_edit_data_text'] || 'Now you can edit data, but it will be overwritten with latest request from QT'}.`, 'warning');
    }
    const handleChange = (event, value) => {
        updateURL(value);
        setTabValue(value);
    };
    const getMobileLogData = async () => {
        let data = await props.onMobileDownload(searchParams.productID, { ActiveCustomerID: activeCustomer });
        if (data?.status !== 200) {
            return snackActions.snackBarComponent(data?.message ?? `${translations['not_find_session'] || 'Could not find session data'}!`, 'error');
        }
        if (data) {
            return downloadFile(data.blob, data.fileName);
        }
    };
    let disabled = (typeof mobileProducts?.loaded === 'boolean' && !mobileProducts?.loaded)

    const getProduct = async () => {
        await onFetchMobileProduct({ActiveCustomerID: activeCustomer, ProductID: searchParams?.productID});
    }

    return (
        <div>
            {!redirectOptions.open && <>
            <Paper className={classes.root}>
                {disabled ? null : BackButton(translations)}
                {tabValue < 6 && tabValue !== 2 ? <Tooltip title={translations["refresh"] || "Refresh"}>
                    <IconButton aria-label={translations["refresh"] || "Refresh"} disabled={disabled} component="div" onClick={() => {
                            setRefresh(true);
                        }}>
                        <Refresh />
                    </IconButton>
                </Tooltip> : null}
                {
                    searchParams.type === 'MobileProduct' ?
                        <Tabs
                            value={tabValue}
                            onChange={handleChange}
                            indicatorColor="primary"
                            style={{ padding: 0 }}
                            textColor="primary"
                            variant="scrollable"
                            scrollButtons="on"
                        >
                            {hasPermission(permissions, 'product_load') ? <Tab disabled={disabled} label={translations["details"] || "Details"} value={0} /> : null}
                            {hasPermission(permissions, 'product_load') ? <Tab disabled={disabled} label={translations["misc"] || "MISC"} value={1}/> : null}
                            {hasPermission(permissions, 'product_audit_record_list') ? <Tab disabled={disabled} label={translations["audit_record"] || "Audit Record"} value={2}/> : null}
                            {hasPermission(permissions, 'oem_part_list') ? <Tab disabled={disabled} label={translations["oem_parts"] || "OEM Parts"} value={3}/> : null}
                            {hasPermission(permissions, 'erasure_report_list') ? <Tab disabled={disabled} label={translations["reports"] || "Reports"} value={4}/> : null}
                            {hasPermission(permissions, 'diagnose_case_round_results_list') && <Tab disabled={disabled} label={translations["diagnose"] || "Diagnose"} value={10} />}
                            {hasPermission(permissions, 'product_load') ? <Tab disabled={disabled} label={translations["media"] || "Media"} value={5}/> : null}
                            {/* {hasPermission(permissions, 'product_load') ? <Tab disabled={disabled} label={translations["presets"] || "Presets"} value={6}/> : null} */}
                            {hasPermission(permissions, 'component_list') ? <Tab disabled={disabled} label={translations["storages"] || "Storages"} value={7}/> : null}
                            {hasPermission(permissions, 'component_list') ? <Tab disabled={disabled} label={translations["memories"] || "Memories"} value={8}/> : null}
                            {hasPermission(permissions, 'component_list') ? <Tab disabled={disabled} label={translations["batteries"] || "Batteries"} value={9}/> : null}
                        </Tabs>
                        : null
                }
            </Paper>
            {hasPermission(permissions, 'product_load') && editable.loading ? <TabPanel index={0} value={tabValue}>  <TabContainer style={{ padding: 0 }} dir={theme.direction}>{!disabled && (tabValue===0 || tabValue === 5) ? <ProductDetails onFetchMobileProduct={onFetchMobileProduct} deletedMedia={deletedMedia} setDeletedMedia={setDeletedMedia} translations={translations} tabValue={tabValue} sendMessage={props.sendMessage} onUnpairBulkExternalMobile={props.onUnpairBulkExternalMobile} onUnpairExternalMobile={props.onUnpairExternalMobile} permissions={permissions} editable={editable?.editable} unlockEdit={unlockEdit} productEditable={props.productEditable} moveToAnotherPalette={props.moveMobileToAnotherPalette} fetchOrders={fetchMobileOrders} onLoadedCleanup={props.mobileProductEditInit} onDeleteProduct={props.onDeleteMobileProduct} getLogData={getMobileLogData} onEditProduct={props.onEditMobileProduct} fetchTypicalProblems={props.onFetchMobileTypicalProblems} fetchGrades={props.onFetchMobileGrades} fetchGradingCategories={props.onFetchMobileGradingCategories} productID={searchParams.productID} type={searchParams.type} product={props.mobileProducts} onFetchProduct={props.onFetchMobileProduct} fetchCollies={props.fetchCollies} setRefresh={setRefresh} refresh={refresh} /> : <ProductDontLoading />}</TabContainer> </TabPanel > : null}
            { hasPermission(permissions, 'product_load') && editable.loading ? <TabPanel index={1} value={tabValue}> <TabContainer style={{ padding: 0 }} dir={theme.direction}>{!disabled && tabValue===1 ? <MobileProductMisc onFetchMobileProduct={onFetchMobileProduct} refresh={refresh} translations={translations} activeCustomer={activeCustomer} permissions={permissions} editable={editable.editable} unlockEdit={unlockEdit} productID={searchParams.productID} product={props.mobileProducts.loaded} onEditProduct={props.onEditMobileProduct} /> : <ProductDontLoading />} </TabContainer>  </TabPanel > : null}
            { hasPermission(permissions, 'product_audit_record_list') && editable.loading ? <TabPanel index={2} value={tabValue}> <TabContainer style={{ padding: 0 }} dir={theme.direction}>{!disabled && tabValue===2 ? <MobileProductAuditRecord refresh={refresh} translations={translations} activeCustomer={activeCustomer} permissions={permissions} editable={editable.editable} productID={searchParams.productID} product={props.mobileProducts.loaded}  /> : <ProductDontLoading />} </TabContainer>  </TabPanel > : null}
            { hasPermission(permissions, 'oem_part_list') && editable.loading ? <TabPanel index={3} value={tabValue}> <TabContainer style={{ padding: 0 }} dir={theme.direction}>{!disabled && tabValue===3 ?
                <OEMPart /> : <ProductDontLoading />} </TabContainer>  </TabPanel > : null}

            { hasPermission(permissions, 'erasure_report_list') && editable.loading ?
                <TabPanel index={4} value={tabValue}> <TabContainer dir={theme.direction}>{!disabled && tabValue === 4 ? <Report onGenerate={onGenerateReportMobile} tabValue={tabValue} productID={searchParams.productID} isSingleTab={true}/> : <ProductDontLoading />}</TabContainer>  </TabPanel > : null}

            { hasPermission(permissions, 'product_load') && editable.loading ? <TabPanel index={5} value={tabValue}> <TabContainer style={{ padding: 0 }} dir={theme.direction}>{!disabled && tabValue===5 ? <MediaGallery productID={searchParams.productID} refresh={refresh} onRefresh={() => setDeletedMedia(true)} entity={translations['product'] || 'Product'} translations={translations} images={mediaArrays.imageArray} videos={mediaArrays.videoArray} audio={mediaArrays.audioArray} signatures={signatures} permissions={permissions} /> : <ProductDontLoading />} </TabContainer>  </TabPanel > : null}
            {/* {hasPermission(permissions, 'product_load') && editable.loading ? 
            <TabPanel index={6} value={tabValue}>
                <TabContainer dir={theme.direction}>{!disabled && tabValue === 6 ? 
                    <Presets loadPresets={getProduct} updatePresets={onUpdatePresets} loadedPreset={mobileProducts.loaded} idParams={{ProductID: searchParams?.productID}}  /> : 
                    <ProductDontLoading />} 
                </TabContainer>    
            </TabPanel> : <></>} */}

            { hasPermission(permissions, 'component_list') && editable.loading ? <TabPanel index={7} value={tabValue}> <TabContainer dir={theme.direction}>{!disabled && tabValue === 7 ? <StorageList editable={editable.editable} translations={translations} tabValue={tabValue} productID={searchParams.productID} /> : <ProductDontLoading />}</TabContainer>  </TabPanel > : null}
            { hasPermission(permissions, 'component_list') && editable.loading ? <TabPanel index={8} value={tabValue}> <TabContainer dir={theme.direction}>{!disabled && tabValue === 8 ? <MemoryList editable={editable.editable} translations={translations} tabValue={tabValue} productID={searchParams.productID} /> : <ProductDontLoading />}</TabContainer>  </TabPanel > : null}
            { hasPermission(permissions, 'component_list') && editable.loading ? <TabPanel index={9} value={tabValue}> <TabContainer dir={theme.direction}>{!disabled && tabValue === 9 ? <BatteryList editable={editable.editable} translations={translations} tabValue={tabValue} productID={searchParams.productID} /> : <ProductDontLoading />}</TabContainer>  </TabPanel > : null}
            { hasPermission(permissions, 'diagnose_case_round_results_list') && editable.loading ? <TabPanel index={10} value={tabValue}> <TabContainer style={{ padding: 0 }} dir={theme.direction}>{!disabled && tabValue === 10 ? <Diagnose onFetchMobileProduct={onFetchMobileProduct} translations={translations} tabValue={tabValue} permissions={permissions} productID={searchParams.productID} ClientType={"mobile"} /> : <ProductDontLoading />}</TabContainer> </TabPanel> : <></>}
            </>}
            {redirectOptions.open ?
                <StatisticModal open={redirectOptions.open}
                                product={redirectOptions.product}
                                handleChangeCustomer={() => handleChangeCustomer(onChangeActiveCustomer, redirectOptions)}
                                handleCloseSafe={() => setRedirectOptions({
                                    ...redirectOptions,
                                    open: !redirectOptions.open
                                })}
                                translations={translations} activeCustomer={activeCustomer} />
                : null}
        </div >
    );
}

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        pcProducts: state.product.pcProducts,
        mobileProducts: state.product.mobileProducts,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        storage: state.product.storageProducts,
        permissions: state?.core?.login?.permissions || []
    };
}

const mapDispatchToProps = dispatch => {
    return {
        onCleanBaseboard: () => dispatch(baseboardActions.cleanState()),
        onCleanBattery: () => dispatch(batteryActions.cleanState()),
        onCleanCpu: () => dispatch(cpuActions.cleanState()),
        onCleanGpu: () => dispatch(gpuActions.cleanState()),
        onCleanMemory: () => dispatch(memoryActions.cleanState()),
        onCleanNic: () => dispatch(nicActions.cleanState()),
        onCleanStorage: () => dispatch(storageActions.cleanState()),
        productEditable: data => dispatch(pcProductActions.productEditable(data)),
        onGenerateReportMobile: (mobileProduct, translations) => dispatch(mobileProductActions.generateReport(mobileProduct, translations)),

        onUnpairExternalMobile: externalID => dispatch(mobileProductActions.unpairExternal(externalID)),
        onUnpairBulkExternalMobile: externalIDs => dispatch(mobileProductActions.unpairBulkExternalMobile(externalIDs)),
        onFetchMobileProduct: product => dispatch(mobileProductActions.loadMobileProduct(product)),
        onEditMobileProduct: product => dispatch(mobileProductActions.editMobileProduct(product)),
        onFetchMobileGrades: product => dispatch(mobileProductActions.fetchGrades(product)),
        onFetchMobileGradingCategories: product => dispatch(mobileProductActions.fetchGradingCategories(product)),
        onFetchMobileTypicalProblems: (id) => dispatch(mobileProductActions.fetchTypicalProblems(id)),
        onBulkDeleteMobileProducts: (id) => dispatch(mobileProductActions.bulkDeleteMobileProducts(id)),
        onDeleteMobileProduct: (product) => dispatch(mobileProductActions.deleteMobileProduct(product)),
        onMobileDownload: (productID, customerID) => dispatch(mobileProductActions.downloadRawData(productID, customerID)),
        mobileProductEditInit: (id) => dispatch(mobileProductActions.loadMobileProductInit(id)),
        fetchMobileOrders: (id) => dispatch(mobileProductActions.fetchOrders(id)),
        moveMobileToAnotherPalette: data => dispatch(mobileProductActions.moveToAnotherPalette(data)),
        onCleanMobileState: () => dispatch(mobileProductActions.cleanState()),
        onChangeActiveCustomer: (customerID, path) => dispatch(action.changeActiveCustomer(customerID, path)),

        onUpdatePresets: data => dispatch(pcProductActions.updatePresets(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(ProductComponents));